export default __webpack_public_path__ + "static/media/greenWave.7cc5983e.svg";